import { chatbotFlexAssets } from '../chatbot/flex';

export const profileAvatarAssets = new Array(24).fill(null).reduce(
  (acc, _, index) => ({
    ...acc,
    [`avatar-${index + 1}`]: `private/avatar/${index + 1}.png`,
  }),
  {},
);

// Export for replicant
export const replicantAssets = {
  // Flex assets
  ...chatbotFlexAssets,

  // Profile pictures
  ...profileAvatarAssets,
};

export type ReplicantAssetKey = keyof typeof replicantAssets;
